import { render, staticRenderFns } from "./Manage-Designation.vue?vue&type=template&id=69b53c7f"
import script from "./Manage-Designation.vue?vue&type=script&lang=js"
export * from "./Manage-Designation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports